import { JSX, useState, useEffect, useRef } from 'react';
import './contentBox.css';
import { useEditor, EditorContent, Editor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit'
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import checkBoxIcon from '../../assets/images/text-editor/list.png';
import boldTextIcon from '../../assets/images/text-editor/bold-text.png'


interface ContentBoxProps {
  todoContent: string;
  onContentChange: (content: string) => void;
  onFocus?: () => void;
}

const ContentBox = ({ todoContent, onContentChange, onFocus }: ContentBoxProps): JSX.Element => {
  
  const editor: Editor | null = useEditor({
    extensions: [
      StarterKit,
        TaskList,
        TaskItem.configure({
          nested: true,
        }),
      ],
      // editorContainerProps: {
      //   'class': 'content-input-box',
      // },
    content: todoContent || `<p>hello</p>`,
      onUpdate: ({ editor }) => {
        const html = editor.getHTML();
        onContentChange(html);
      },
      editorProps: {
        attributes: {
          'class': 'content-input-box',
          'data-placeholder': "hello",
        },
        handleKeyDown: (view, event) => {
          // Handle Tab key (like your original handleTabKey)
          if (event.key === 'Tab') {
            event.preventDefault();
            // Add custom tab behavior here if needed
            if (event.shiftKey) {
              // Outdent
              return editor?.commands.liftListItem('listItem') || false;
            } else {
              // Indent
              return editor?.commands.sinkListItem('listItem') || false;
            }
          }
          return false;
        },
      },
      // React to external content changes
      onFocus: () => {
        if (onFocus) {
          onFocus();
        }
      },
  });

  const addTaskList = () => {
    // Check if editor exists and the command is available
    editor?.commands.toggleTaskList();
  };

  useEffect(() => {
    if (editor && todoContent !== editor.getHTML()) {
      editor.commands.setContent(todoContent || '');
    }

    console.log(todoContent);
  }, [todoContent, editor]);

  return (
    <div className='contentbox-container' onFocus={onFocus}>
      <div className='toolbar-container'>
        <img className='toolbar-icon' src={boldTextIcon} onClick={() => {}}/>
        {/* <div className='divider'/> */}
        <img className='toolbar-icon' src={checkBoxIcon} onClick={addTaskList}/>
        {/* <div className='divider'/> */}
      </div>
      <div className='divider-horizontal'/>
      <EditorContent editor={editor} className="editor-container"/>
    </div>
  ); 
};
  
export default ContentBox;